/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddClientAllClaimDto,
    AddClientAllClaimDtoFromJSON,
    AddClientAllClaimDtoToJSON,
} from '../models/AddClientAllClaimDto';
import {
    type ParticipantRoleReadDto,
    ParticipantRoleReadDtoFromJSON,
    ParticipantRoleReadDtoToJSON,
} from '../models/ParticipantRoleReadDto';
import {
    type ParticipantUserClaimReadDto,
    ParticipantUserClaimReadDtoFromJSON,
    ParticipantUserClaimReadDtoToJSON,
} from '../models/ParticipantUserClaimReadDto';
import {
    type ParticipantUserReadDto,
    ParticipantUserReadDtoFromJSON,
    ParticipantUserReadDtoToJSON,
} from '../models/ParticipantUserReadDto';
import {
    type RemoveClientAllClaimDto,
    RemoveClientAllClaimDtoFromJSON,
    RemoveClientAllClaimDtoToJSON,
} from '../models/RemoveClientAllClaimDto';

export interface UiApiParticipantsUsersPUserIdClaimsAvailableGetRequest {
    pUserId: number;
}

export interface UiApiParticipantsUsersPUserIdClaimsGetRequest {
    pUserId: number;
}

export interface UiApiParticipantsUsersUserIdAdminPermissionsPostRequest {
    userId: number;
    body: boolean;
}

export interface UiApiParticipantsUsersUserIdClaimsAddPostRequest {
    userId: number;
    addClientAllClaimDto: Array<AddClientAllClaimDto>;
}

export interface UiApiParticipantsUsersUserIdClaimsRemoveDeleteRequest {
    userId: number;
    removeClientAllClaimDto: Array<RemoveClientAllClaimDto>;
}

export interface UiApiParticipantsUsersUserIdGetRequest {
    userId: number;
}

export interface UiApiParticipantsUsersUserIdGroupsAddPostRequest {
    userId: number;
    requestBody: Array<number>;
}

export interface UiApiParticipantsUsersUserIdGroupsAvailableGetRequest {
    userId: number;
}

export interface UiApiParticipantsUsersUserIdGroupsGetRequest {
    userId: number;
}

export interface UiApiParticipantsUsersUserIdGroupsRemoveDeleteRequest {
    userId: number;
    requestBody: Array<number>;
}

/**
 * 
 */
export class UiApiParticipantsUsersApi extends runtime.BaseAPI {

    /**
     * Creates request options for uiApiParticipantsUsersPUserIdClaimsAvailableGet without sending the request
     */
    async uiApiParticipantsUsersPUserIdClaimsAvailableGetRequestOpts(requestParameters: UiApiParticipantsUsersPUserIdClaimsAvailableGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pUserId'] == null) {
            throw new runtime.RequiredError(
                'pUserId',
                'Required parameter "pUserId" was null or undefined when calling uiApiParticipantsUsersPUserIdClaimsAvailableGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants-users/{pUserId}/claims/available`;
        urlPath = urlPath.replace('{pUserId}', encodeURIComponent(String(requestParameters['pUserId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async uiApiParticipantsUsersPUserIdClaimsAvailableGetRaw(requestParameters: UiApiParticipantsUsersPUserIdClaimsAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParticipantUserClaimReadDto>>> {
        const requestOptions = await this.uiApiParticipantsUsersPUserIdClaimsAvailableGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantUserClaimReadDtoFromJSON));
    }

    /**
     */
    async uiApiParticipantsUsersPUserIdClaimsAvailableGet(requestParameters: UiApiParticipantsUsersPUserIdClaimsAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParticipantUserClaimReadDto>> {
        const response = await this.uiApiParticipantsUsersPUserIdClaimsAvailableGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersPUserIdClaimsGet without sending the request
     */
    async uiApiParticipantsUsersPUserIdClaimsGetRequestOpts(requestParameters: UiApiParticipantsUsersPUserIdClaimsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pUserId'] == null) {
            throw new runtime.RequiredError(
                'pUserId',
                'Required parameter "pUserId" was null or undefined when calling uiApiParticipantsUsersPUserIdClaimsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants-users/{pUserId}/claims`;
        urlPath = urlPath.replace('{pUserId}', encodeURIComponent(String(requestParameters['pUserId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async uiApiParticipantsUsersPUserIdClaimsGetRaw(requestParameters: UiApiParticipantsUsersPUserIdClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParticipantUserClaimReadDto>>> {
        const requestOptions = await this.uiApiParticipantsUsersPUserIdClaimsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantUserClaimReadDtoFromJSON));
    }

    /**
     */
    async uiApiParticipantsUsersPUserIdClaimsGet(requestParameters: UiApiParticipantsUsersPUserIdClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParticipantUserClaimReadDto>> {
        const response = await this.uiApiParticipantsUsersPUserIdClaimsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdAdminPermissionsPost without sending the request
     */
    async uiApiParticipantsUsersUserIdAdminPermissionsPostRequestOpts(requestParameters: UiApiParticipantsUsersUserIdAdminPermissionsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdAdminPermissionsPost().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling uiApiParticipantsUsersUserIdAdminPermissionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants-users/{userId}/admin-permissions`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdAdminPermissionsPostRaw(requestParameters: UiApiParticipantsUsersUserIdAdminPermissionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdAdminPermissionsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uiApiParticipantsUsersUserIdAdminPermissionsPost(requestParameters: UiApiParticipantsUsersUserIdAdminPermissionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uiApiParticipantsUsersUserIdAdminPermissionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdClaimsAddPost without sending the request
     */
    async uiApiParticipantsUsersUserIdClaimsAddPostRequestOpts(requestParameters: UiApiParticipantsUsersUserIdClaimsAddPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdClaimsAddPost().'
            );
        }

        if (requestParameters['addClientAllClaimDto'] == null) {
            throw new runtime.RequiredError(
                'addClientAllClaimDto',
                'Required parameter "addClientAllClaimDto" was null or undefined when calling uiApiParticipantsUsersUserIdClaimsAddPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants-users/{userId}/claims/add`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['addClientAllClaimDto']!.map(AddClientAllClaimDtoToJSON),
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdClaimsAddPostRaw(requestParameters: UiApiParticipantsUsersUserIdClaimsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdClaimsAddPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uiApiParticipantsUsersUserIdClaimsAddPost(requestParameters: UiApiParticipantsUsersUserIdClaimsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uiApiParticipantsUsersUserIdClaimsAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdClaimsRemoveDelete without sending the request
     */
    async uiApiParticipantsUsersUserIdClaimsRemoveDeleteRequestOpts(requestParameters: UiApiParticipantsUsersUserIdClaimsRemoveDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdClaimsRemoveDelete().'
            );
        }

        if (requestParameters['removeClientAllClaimDto'] == null) {
            throw new runtime.RequiredError(
                'removeClientAllClaimDto',
                'Required parameter "removeClientAllClaimDto" was null or undefined when calling uiApiParticipantsUsersUserIdClaimsRemoveDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants-users/{userId}/claims/remove`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['removeClientAllClaimDto']!.map(RemoveClientAllClaimDtoToJSON),
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdClaimsRemoveDeleteRaw(requestParameters: UiApiParticipantsUsersUserIdClaimsRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdClaimsRemoveDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uiApiParticipantsUsersUserIdClaimsRemoveDelete(requestParameters: UiApiParticipantsUsersUserIdClaimsRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uiApiParticipantsUsersUserIdClaimsRemoveDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdGet without sending the request
     */
    async uiApiParticipantsUsersUserIdGetRequestOpts(requestParameters: UiApiParticipantsUsersUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants-users/{userId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGetRaw(requestParameters: UiApiParticipantsUsersUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParticipantUserReadDto>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParticipantUserReadDtoFromJSON(jsonValue));
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGet(requestParameters: UiApiParticipantsUsersUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParticipantUserReadDto> {
        const response = await this.uiApiParticipantsUsersUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdGroupsAddPost without sending the request
     */
    async uiApiParticipantsUsersUserIdGroupsAddPostRequestOpts(requestParameters: UiApiParticipantsUsersUserIdGroupsAddPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdGroupsAddPost().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling uiApiParticipantsUsersUserIdGroupsAddPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants-users/{userId}/groups/add`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsAddPostRaw(requestParameters: UiApiParticipantsUsersUserIdGroupsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdGroupsAddPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsAddPost(requestParameters: UiApiParticipantsUsersUserIdGroupsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uiApiParticipantsUsersUserIdGroupsAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdGroupsAvailableGet without sending the request
     */
    async uiApiParticipantsUsersUserIdGroupsAvailableGetRequestOpts(requestParameters: UiApiParticipantsUsersUserIdGroupsAvailableGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdGroupsAvailableGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants-users/{userId}/groups/available`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsAvailableGetRaw(requestParameters: UiApiParticipantsUsersUserIdGroupsAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParticipantRoleReadDto>>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdGroupsAvailableGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantRoleReadDtoFromJSON));
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsAvailableGet(requestParameters: UiApiParticipantsUsersUserIdGroupsAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParticipantRoleReadDto>> {
        const response = await this.uiApiParticipantsUsersUserIdGroupsAvailableGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdGroupsGet without sending the request
     */
    async uiApiParticipantsUsersUserIdGroupsGetRequestOpts(requestParameters: UiApiParticipantsUsersUserIdGroupsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdGroupsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants-users/{userId}/groups`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsGetRaw(requestParameters: UiApiParticipantsUsersUserIdGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParticipantRoleReadDto>>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdGroupsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantRoleReadDtoFromJSON));
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsGet(requestParameters: UiApiParticipantsUsersUserIdGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParticipantRoleReadDto>> {
        const response = await this.uiApiParticipantsUsersUserIdGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsUsersUserIdGroupsRemoveDelete without sending the request
     */
    async uiApiParticipantsUsersUserIdGroupsRemoveDeleteRequestOpts(requestParameters: UiApiParticipantsUsersUserIdGroupsRemoveDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uiApiParticipantsUsersUserIdGroupsRemoveDelete().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling uiApiParticipantsUsersUserIdGroupsRemoveDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants-users/{userId}/groups/remove`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsRemoveDeleteRaw(requestParameters: UiApiParticipantsUsersUserIdGroupsRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.uiApiParticipantsUsersUserIdGroupsRemoveDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uiApiParticipantsUsersUserIdGroupsRemoveDelete(requestParameters: UiApiParticipantsUsersUserIdGroupsRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uiApiParticipantsUsersUserIdGroupsRemoveDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
